import { useEffect } from 'react';
import { isProd, loadEmbeddedScript } from '../component/utils/app-utils';
import { useMCPBeacon } from './featureFlagProvider';

const MCP_BEACON_SRC =
  '//cdn.evgnet.com/beacon/usfireins/figo_mcp_dataset/scripts/evergage.min.js';
const MCP_BEACON_PROD_SRC =
  '//cdn.evgnet.com/beacon/usfireins/prodfigo/scripts/evergage.min.js';

const useMCPBeaconScript = () => {
  const useBeacon = useMCPBeacon();

  useEffect(() => {
    if (useBeacon) {
      loadEmbeddedScript({
        scriptAsync: false,
        scriptDefer: false,
        scriptId: 'mcpBeacon',
        scriptSrc: isProd ? MCP_BEACON_PROD_SRC : MCP_BEACON_SRC,
      });
    }
  }, [useBeacon]);

  return {
    active: !!window.SalesforceInteractions,
  };
};

export { useMCPBeaconScript };
